import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { ICONS_COLOR_MAPPING as r } from "./index.es2447.js";
const d = ({ outline: e = "default-gray", ...t }) => {
  const i = r[e];
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ l("rect", { width: "16", height: "16", rx: "8", fill: "var(--plac-lines-default)" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.28131 4.22052C4.98841 3.92763 4.51354 3.92763 4.22065 4.22052C3.92775 4.51342 3.92775 4.98829 4.22065 5.28118L6.93946 8L4.22065 10.7188C3.92775 11.0117 3.92775 11.4866 4.22065 11.7795C4.51354 12.0724 4.98841 12.0724 5.28131 11.7795L8.00012 9.06066L10.7189 11.7795C11.0118 12.0724 11.4867 12.0724 11.7796 11.7795C12.0725 11.4866 12.0725 11.0117 11.7796 10.7188L9.06078 8L11.7796 5.28118C12.0725 4.98829 12.0725 4.51342 11.7796 4.22052C11.4867 3.92763 11.0118 3.92763 10.7189 4.22052L8.00012 6.93934L5.28131 4.22052Z",
            fill: i
          }
        )
      ]
    }
  );
};
export {
  d as UtilityCloseIcon
};
//# sourceMappingURL=index.es456.js.map
